module.exports = __webpack_public_path__ + "img/mouse.67ccdc5d.svg";